import React from "react";
import FormField from "./FormField";
import { format } from "date-fns";

interface DateInputFieldProps {
  id: string;
  label: string;
  value: Date;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string; // Optional type, defaults to "text"
  className?: string; // Optional additional class names for the input
}

const DateInputField: React.FC<DateInputFieldProps> = ({
  id,
  label,
  value,
  onChange,
  type = "date",
  className = "",
}) => {
  return (
    <FormField htmlFor={id} label={label}>
      <input
        id={id}
        type={type}
        value={format(value, "yyyy-MM-dd")}
        onChange={onChange}
        className={`focus:border-soluud-primary focus:ring-soluud-primary/30 block w-full rounded-lg border border-gray-300 py-2 pr-3 pl-3 text-base transition-colors duration-150 focus:ring-2 focus:outline-none sm:text-sm ${className}`}
      />
    </FormField>
  );
};

export default DateInputField;
